import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'

interface useDeleteBadgeParams {
  id: number | null | undefined
}

interface useDeleteBadgeProps {
  onSuccess?: (data: undefined, variables: useDeleteBadgeParams) => void
  onError?: (error: Error, variables: useDeleteBadgeParams) => void
}

export const useDeleteBadgeById = ({
  onSuccess,
  onError,
}: useDeleteBadgeProps) => {
  const deleteBadge = useTypedApiClient({
    path: '/admin/badgerewards/{id}',
    method: 'delete',
  })
  const queryClient = useQueryClient()

  return useMutation<any, Error, useDeleteBadgeParams>({
    mutationFn: async ({ id }: useDeleteBadgeParams) => {
      await deleteBadge({ id: Number(id) })
    },
    onSuccess: async (data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: ['/admin/badgerewards'],
      })
      onSuccess?.(data, variables)
    },
    onError,
  })
}
